import { render } from "./ObjectiveViewRowActions.vue?vue&type=template&id=f4d284b6"
import script from "./ObjectiveViewRowActions.vue?vue&type=script&lang=js"
export * from "./ObjectiveViewRowActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__